/**
 * @typedef {import('../../../shared/Query').QueryParameters} QueryParameters
 */

import { translate } from '../../../Internationalization';
import flags from '../../../../shared/Flags';
import GenericContactsTable from './Generic/GenericContactsTable';
import GenericMoversOverlay from './Generic/GenericMoversOverlay';
import LeadScoreBoard from './LeadScoreBoard/LeadScoreBoard';
import Loading from '../../../../shared/Loading';
import Movers from './Movers';
import NoContent from '../../../../shared/NoContent';
import React from 'react';
import useGetAgentContacts from '../../../../Hooks/Agent/Getters/useGetAgentContacts/useGetAgentContacts';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';

/** @type {QueryParameters} */
const defaultQuery = {
	limit: 5,
	'sort[lead_scores.0.score]': 'desc',
	'sort[name.last]': 'asc',
	// eslint-disable-next-line sort-keys
	'sort[name.first]': 'asc',
};

/** @returns {JSX.Element} */
export default function ContactAnalysis() {
	const gated = useIsGated(flags.agent.mis);
	const agentContacts = useGetAgentContacts(gated.isGated, defaultQuery);

	if (gated.isGettingData || agentContacts.isGettingData) {
		return <Loading />;
	}

	if (gated.isGated) {
		return (
			<section className="my-5">
				<GenericMoversOverlay
					titleKey="agent.pages.dashboard.movers.labels.likely"
					descriptionKey="agent.pages.dashboard.movers.upgraded.likely_description"
				/>
				<GenericContactsTable />
			</section>
		);
	}

	if (agentContacts.errorMessage || !agentContacts.data) {
		return (
			<NoContent
				message={translate('agent.pages.contacts.errors.fetch')}
			/>
		);
	}

	return (
		<section className="my-5">
			<Movers moverCounts={agentContacts?.data?.moverCounts} />
			<LeadScoreBoard contactList={agentContacts?.data?.contacts} />
		</section>
	);
}
